import React from "react";
import { navigate } from "gatsby";
import { LinkItemType } from "../../../types";
import Button from "../../shared/Button";
import TextInput from "../../shared/FormComponents/TextInput";

const EmailRedirect = ({ linkItem }: { linkItem: LinkItemType }) => {

    const [error, setError] = React.useState<string | null>(null);
    const [email, setEmail] = React.useState("");

    if (!linkItem || !(linkItem?.src)) {
        return <></>;
    }

    const handleButtonClick = () => {

        if (!email) {
            setError("Please enter an email address.")
            return;
        }

        const scr = `${linkItem.src}`;
        if (linkItem.target === "_blank") {
            window.open(linkItem.src, "_blank");
        } else {
            navigate(scr, { state: { email } });
        }
    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setEmail(e.target.value);
        setError(null);
    }

    return (
        <>
            {error && <div className="text-red-500 text-lg pb-2">{error}</div>}
            <div className="text-lg font-bold pb-2">
                Email Address
            </div>
            <div className="flex -mx-2">
                <div className="px-2 flex-1 max-w-[500px]">
                    <TextInput className="w-full" color="white" borderColor="primary" value={email} onChange={handleEmailChange} />
                </div>
                <div className="px-2">
                    <Button onClick={handleButtonClick}>
                        {linkItem.text}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default EmailRedirect;
